import { types as auth } from '../actions/auth'
import { types as sites } from '../actions/sites'
import { types as group } from '../actions/groups'
import { types as tokens } from '../actions/tokens'

const initialState = {
  sites: [],
  tokens: [],
  current: null
}

export default (state = initialState, action) => {
  let index

  switch (action.type) {
    case auth.OK:
      return {...state,
        sites: action.data.sites
      }

    case sites.CHANGE:
      return {...state,
        current: action.data
      }

    case sites.SAVE:
      index = state.sites.findIndex(site => site.id === action.data.id)
      if (index > -1) {
        return {...state,
          sites: [
            ...state.sites.slice(0, index),
            action.data,
            ...state.sites.slice(index + 1)
          ]
        }
      } else {
        return {...state,
          lastSaved: action.data.id,
          sites: [...state.sites, action.data]
        }
      }

    case sites.DELETE:
      index = state.sites.findIndex(site => site.id === action.data.id)
      return {...state,
        sites: [
          ...state.sites.slice(0, index),
          ...state.sites.slice(index + 1)
        ]
      }

    case group.SAVE:
      const arr = state.current.groups || []
      index = arr.findIndex(group => group.id === action.data.group.id)
      if (index === -1) index = arr.length
      return {...state,
        current: {...state.current, groups: [
          ...arr.slice(0, index),
          action.data.group,
          ...arr.slice(index + 1)
        ]}
      }

    case group.DELETE:
      index = state.current.groups.findIndex(group => group.id === action.data.group.id)
      return {...state,
        current: {...state.current, groups: [
          ...state.current.groups.slice(0, index),
          ...state.current.groups.slice(index + 1)
        ]}
      }

    case sites.LOAD_TOKENS:
      return {...state,
        tokens: action.data
      }

    case sites.SAVE_TOKEN:
      return {...state,
        tokens: [...state.tokens, action.data]
      }

    case tokens.DELETE:
      index = state.tokens.findIndex(token => token.id === action.data.id)
      if (index < 0) return state
      return {...state,
        tokens: [
          ...state.tokens.slice(0, index),
          ...state.tokens.slice(index + 1)
        ]
      }

    case auth.FAIL:
    case auth.LOGOUT:
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./app/reducers/sites.js